require("./style.css");
import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import PieChartHighlight from "./PieChartHighlight";
import VerticalBarChart from "./VerticalBarChart";
import sortBy from "lodash/sortBy";

export default class SegmentCultureReport extends AcquireWebComponent {
  formatData(arr) {
    if (!arr || !(arr instanceof Array) || arr.length === 0) return [];
    const allCount = arr.reduce((a, b) => {
      if (typeof a !== "number") return a.value + b.value;
      else return a + b.value;
    });
    arr.forEach(it => {
      it.percentage = it.value / allCount;
    });
    return arr;
  }

  render() {
    const data = this.props.data || {};
    const json = Object.keys(data).join();
    let aaAcculturation = [];
    let hhAcculturation = [];
    data.acculturation &&
      data.acculturation.values &&
      data.acculturation.values.forEach(it => {
        const keyName = it.key.split(":");
        it._key = keyName[0];
        it.middleVal = keyName[1];
        if (it.key.includes("AA")) {
          aaAcculturation.push(it);
        } else {
          hhAcculturation.push(it);
        }
      });
    const acculturation = this.formatData(
      data.acculturation && data.acculturation.values,
    );
    const aa = this.formatData(aaAcculturation).filter(it => {
      return Math.round(it.percentage * 10000) > 0;
    });
    const hh = this.formatData(hhAcculturation).filter(it => {
      return Math.round(it.percentage * 10000) > 0;
    });
    const ethnicity = this.formatData(
      data.ethnicity && data.ethnicity.values,
    ).filter(it => {
      return Math.round(it.percentage * 10000) > 0;
    });
    const region = this.formatData(data.region && data.region.values).filter(
      it => {
        return Math.round(it.percentage * 10000) > 0;
      },
    );
    const _region = !this.props.onPdfReportDownload
      ? region
      : region.map(it => {
          return {
            ...it,
            key: "",
          };
        });
    const colStyle = {
      width: "50%",
    };
    return (
      <div>
        <div
          style={{
            display: "none",
            padding: "20px",
            background: "#D9DBDD",
            color: "#000",
            fontWeight: "bold",
            marginTop: "20px",
          }}
          className="pdf-extra-container"
        >
          Culture Codes
        </div>
        <div
          className="segment-culture-report"
          style={{ ...this.props.style, paddingTop: "20px" }}
        >
          <div
            className="left-col"
            style={{ ...colStyle, paddingRight: "10px" }}
          >
            <div className="light-grey-border">
              {ethnicity && ethnicity.length > 0 && (
                <PieChartHighlight
                  data={ethnicity}
                  title={data.ethnicity.name}
                  dataKey="value"
                  stateName={"Ethnicity"}
                  fieldTitle="Percent"
                  showList={true}
                  showDetail={true}
                  showPercentage={true}
                />
              )}
            </div>
            <div className="light-grey-border mt-20">
              {acculturation && acculturation.length > 0 && (
                <div>
                  <PieChartHighlight
                    data={hh}
                    title={data.acculturation ? data.acculturation.name : ""}
                    dataKey="value"
                    stateName={"Code"}
                    middleKey="Hispanicity"
                    fieldTitle="Percent"
                    showList={true}
                    showDetail={true}
                    showPercentage={true}
                  />
                  <PieChartHighlight
                    data={aa}
                    title={""}
                    dataKey="value"
                    stateName={"Code"}
                    middleKey="Asianicity"
                    fieldTitle="Percent"
                    showList={true}
                    showDetail={true}
                    showPercentage={true}
                  />
                </div>
              )}
            </div>
          </div>
          <div
            className="right-col"
            style={{ ...colStyle, paddingLeft: "10px" }}
          >
            <div className="light-grey-border mb-20 culture-region">
              {region && region.length > 0 && (
                <div>
                  <div style={{ position: "relative" }}>
                    <VerticalBarChart
                      data={_region}
                      title={data.region.name}
                      chartMargin={{
                        top: 0,
                        right: 20,
                        left: 20,
                        bottom: 20,
                      }}
                      yMirror={true}
                      yTickHide={true}
                      yAxisWidth={300}
                      height={74 * region.length + "px"}
                    ></VerticalBarChart>
                    <div
                      className="extra-vertical-bar-chart-y-axis pdf-extra-container"
                      style={{
                        position: "absolute",
                        top: "0px",
                        bottom: "0px",
                        left: "0px",
                        right: "0px",
                        padding: "86px 0 60px 30px",
                        display: "none",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        {region.map(it => {
                          return (
                            <div
                              key={it.key}
                              className="extra-y-axis"
                              style={{
                                height: "17.39px",
                                transform: "translateY(-20px)",
                              }}
                            >
                              {it.key}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="mt-20 mb-20">
                    <div
                      style={{
                        padding: "10px 20px",
                        margin: "-20px 20px -5px",
                        background: "#F5F5F5",
                        fontWeight: "bold",
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div style={{ flex: "1 1 50%" }}>Region</div>
                        <div style={{ flex: "1 1 50%", textAlign: "right" }}>
                          Percent
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        padding: "0",
                        margin: "0px 20px",
                        height: "5px",
                        borderBottom: "solid 1px #EEEFF2 ",
                      }}
                    >
                      &nbsp;
                    </div>
                    {sortBy(region, "percentage")
                      .reverse()
                      .map((entry, idx) => {
                        return (
                          <div
                            key={"sortdata-" + idx}
                            style={{
                              display: "flex",
                              padding: "10px 20px",
                              margin: "0px 20px",
                              borderBottom: "solid 1px #EEEFF2 ",
                            }}
                          >
                            <div
                              style={{
                                width: "80%",
                                paddingLeft: "0px",
                              }}
                            >
                              {entry.key}
                            </div>
                            <div style={{ width: "20%", textAlign: "right" }}>
                              {parseFloat((entry.percentage * 100).toFixed(2)) +
                                "%"}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Insights/distribution/SegmentCultureReport.jsx